import { z } from "zod";
export const ALLOWED_ANALYSIS_MODELS = [
    "gpt-5.4",
    "gpt-5.2",
    "gpt-4o-mini",
    "gemini-3-flash",
    "gemini-3.1-pro-preview",
    "claude-sonnet-4-6",
    "claude-opus-4-6",
    "gpt-5-mini",
];
export const analysisModelIdSchema = z.enum(ALLOWED_ANALYSIS_MODELS);
export const analysisModelPreferenceValueSchema = z.object({
    model: analysisModelIdSchema,
});
export const modelInfoSchema = z.object({
    modelId: analysisModelIdSchema,
    apiModelName: z.string(),
    provider: z.enum(["openrouter"]),
    displayName: z.string(),
    poweredBy: z.string(),
    contextWindow: z.number(),
    maxOutputTokens: z.number().optional(),
});
export const selectModelRequestSchema = z.object({
    modelId: analysisModelIdSchema,
});
export const getModelPreferencesResponseSchema = z.object({
    models: z.array(modelInfoSchema),
    current: analysisModelPreferenceValueSchema,
});
export const selectModelResponseSchema = z.object({
    success: z.boolean(),
    modelId: analysisModelIdSchema,
});
